import { useState } from "react";
import { ChevronDown, RefreshCw } from "lucide-react";
import { toast } from "sonner";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import useAuthorized from "hooks/useAuthorized";
import ChangeLeadStatusModal from "routes/leads/table/ChangeLeadStatusModal";
import { leadAclForScope } from "routes/leads/table/leadScope";

export function LeadsBulkActions({
  scope,
  selectedIds = [],
  events = [],
  uncheckAll,
  bulkUpdateStatus,
}) {
  const [statusOpen, setStatusOpen] = useState(false);

  const canEdit = useAuthorized([leadAclForScope(scope).edit]);

  if (!canEdit) return null;

  const handleStatus = async statusId => {
    try {
      await bulkUpdateStatus(selectedIds, statusId);
      uncheckAll();
      toast.success("Lead statuses updated");
    } catch {
      toast.error("Failed to update lead statuses");
      throw new Error("Failed to update lead statuses");
    }
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          className={buttonVariants({ variant: "outline" })}
          disabled={selectedIds.length === 0}
        >
          Actions
          <ChevronDown />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          <DropdownMenuGroup>
            <DropdownMenuItem onClick={() => setStatusOpen(true)}>
              <RefreshCw />
              Change Status
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
      <ChangeLeadStatusModal
        events={events}
        title="Change Lead Status"
        open={statusOpen}
        onOpenChange={setStatusOpen}
        onConfirm={handleStatus}
      />
    </>
  );
}
